import { JSX, useState } from "react";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";

import './template.css';

type TemplatePorps = {
    children: JSX.Element | JSX.Element[],
    menuActive: string
}

export default function Template({ children, menuActive }: TemplatePorps) {
    const [sidebarOpen, setSidebarOpen] = useState(true);

    const handleSidebarClose = () => {
        setSidebarOpen(false);
    };

    const handleSidebarToggle = () => {
        setSidebarOpen(!sidebarOpen);
    };

    return (
        <div>
            <Topbar onMenuClick={handleSidebarToggle} />
            <Sidebar open={sidebarOpen} onClose={handleSidebarClose} menuActive={menuActive} />
            <div id="view" style={{ marginTop: 70, marginLeft: sidebarOpen ? 245 : 0 }}>
                {children}
            </div>
        </div>
    );
}